import axios from "axios";

const API_URL = process.env.REACT_APP_URL;

export const getAllNewsletters = async (idlanguage) => {
  try {
    const params = {};
    if (idlanguage) {
      params.idlanguage = idlanguage;
    }
    var fullUrl = API_URL + "newsletters/newsletters?idlanguage=" + idlanguage;
    const response = await axios.get(fullUrl);
    if (!response.data) return [];
    return response.data.sort((a, b) => new Date(b.date_sortie) - new Date(a.date_sortie));
  } catch (error) {
    console.error("Erreur lors de la récupération des newsletters :", error);
    throw error;
  }
};

export const getNewsletterByNumero = async (numero, idlanguage) => {
  try {
    const fullUrl =
      API_URL +
      "newsletters/newsletters?numero=" +
      numero +
      "&idlanguage=" +
      idlanguage;
    const response = await axios.get(fullUrl);
    const data = await response.data;
    return data[0];
  } catch (error) {
    console.error(
      `Erreur lors de la récupération de la newsletter ${numero} :`,
      error,
    );
    throw error;
  }
};

export const getNewsletterById = async (id) => {
  try {
    const response = await axios.get(`${API_URL}newsletters/${id}`);
    return response.data;
  } catch (error) {
    console.error(
      `Erreur lors de la récupération de la newsletter ${id} :`,
      error,
    );
    throw error;
  }
};

export const createNewsletter = async (newsletter, file) => {
  try {
    const formData = new FormData();
    // Ajoute le JSON newsletter
    formData.append(
      "newsletter",
      new Blob([JSON.stringify(newsletter)], { type: "application/json" }),
    );
    // Ajoute le fichier image si présent
    if (file) {
      formData.append("file", file);
    }
    const response = await axios.post(API_URL + "newsletters", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la création de la newsletter :", error);
    throw error;
  }
};

export const updateNewsletter = async (id, updatedNewsletter, file) => {
  try {
    const formData = new FormData();

    // Ajoute l'objet newsletter en JSON
    formData.append(
      "newsletter",
      new Blob([JSON.stringify(updatedNewsletter)], {
        type: "application/json",
      }),
    );

    // Si un fichier est fourni, on l'ajoute
    if (file) {
      formData.append("file", file);
    }

    const response = await axios.put(`${API_URL}newsletters/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    console.error(
      `Erreur lors de la mise à jour de la newsletter ${id} :`,
      error,
    );
    throw error;
  }
};

export const deleteNewsletter = async (id) => {
  try {
    await axios.delete(`${API_URL}newsletters/${id}`);
    return true;
  } catch (error) {
    console.error(
      `Erreur lors de la suppression de la newsletter ${id} :`,
      error,
    );
    throw error;
  }
};

export const softDeleteNewsletter = async (id) => {
  try {
    await axios.patch(`${API_URL}newsletters/${id}/soft-delete`);
    return true;
  } catch (error) {
    console.error(`Erreur lors du soft delete de la newsletter ${id} :`, error);
    throw error;
  }
};
